// Copyright 2026. WebPros International GmbH. All rights reserved.
import { combineReducers } from 'redux';
import {
    IPaginateApiResponse,
    paginateInitialState,
} from 'common/api/resources/Response';
import {
    ActionType,
    getType,
} from 'typesafe-actions';
import * as vGpuProfileActions from 'common/modules/vGpuProfiles/actions';
import { IVGpuProfile } from 'common/api/resources/Gpu';

export type VGpuProfileAction = ActionType<typeof vGpuProfileActions>;

export interface IVGpuProfileState {
    list: IPaginateApiResponse<IVGpuProfile[]>;
}

export type VGpuProfileState = IVGpuProfileState;

export const mockVGpuProfile: IVGpuProfile = {
    id: 0,
    name: 'NVIDIA L4-1B',
    max_instances: 24,
    frame_rate_limit_fps: 45,
    frame_buffer_memory_mb: 1024,
    placement_ids: [1, 2, 3, 4, 5],
    grid_license: 'Grid license text',
};

export default combineReducers<VGpuProfileState, VGpuProfileAction>({
    list: (state = paginateInitialState, action: VGpuProfileAction) => {
        switch (action.type) {
        case getType(vGpuProfileActions.setVGpuProfileList):
            return action.payload;
        default:
            return state;
        }
    },
});
